export default {
    inserted: function (el, binding, vnode) {
        el.addEventListener("click", function(e){
            e.preventDefault();

            if (binding.value.modifier) {
                applyModifier(vnode.context.$refs[binding.value.ref].value);
                vnode.context.$refs[binding.value.ref].select();
            } else {
                vnode.context.$refs[binding.value.ref].select();
                document.execCommand("copy");

            }

            el.classList.add('is-ok');
        });

        el.addEventListener('animationend', function(e){
            el.classList.remove('is-ok');
        });

        const applyModifier = (str) => {
            // https://stackoverflow.com/questions/31593297/using-execcommand-javascript-to-copy-hidden-text-to-clipboard

            const tempInput = document.createElement('textarea');
            tempInput.style = "position: absolute; left: -1000px; top: -1000px";
            tempInput.value = binding.value.modifier(str);
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        }
    }
}
